import { checkActivity, checkAchievement } from "./dataModels";
import { apiCall } from "./fetchApi";
import * as myCrypto from './mycrypto_browser';

const encKey = 'b14ca9745a4e2794bbce2ea2315a1410';
const ourGroup = 'def';

const dataAddAchievementAsync = async (achievement) => {
    console.log('dataAddAchievementAsync', achievement.coreId, achievement.actionId, achievement.badgeId);
    try {
        if (!achievement.group) achievement.group = ourGroup;
        achievement.type = 'achievement';
        if (!checkAchievement(achievement)) {
            return { error: "Invalid achievement object" }
        }

        const response = await apiCall('POST', 1, null, 'achievements', '', '', '', achievement);

        return response;
    } catch (error) {
        return error
    }
};

const dataAddAchievementsBatchAsync = async (achievements) => {
    console.log('dataAddAchievementsBatchAsync', achievements.length);
    try {
        if (!achievements || !Array.isArray(achievements) || achievements.length === 0) {
            return { error: "Invalid achievements array" }
        }
        let isAnyInvalid = false;
        achievements = achievements.reduce((acc, achievement) => {
            if (!achievement.group) achievement.group = ourGroup;
            achievement.type = 'achievement';
            let isok = (checkAchievement(achievement));
            acc.push(isok);
            if (!isok) {
                isAnyInvalid = true;
            }
            return acc;
        }, []);
        if (isAnyInvalid) {
            return { error: "Invalid achievement object" }
        }
        if (achievements.length === 1) {
            return dataAddAchievementAsync(achievements[0]);
        }

        const response = await apiCall('POST', achievements.length, null, 'achievements', '', '', '', achievements);

        return response;
    } catch (error) {
        return error
    }
};

const dataUpdateAchievementAsync = async (achievement) => {
    console.log('dataUpdateAchievementAsync', achievement.id, achievement.coreId, achievement.actionId);
    try {
        if (!checkAchievement(achievement) || !achievement.id) {
            return { error: "Invalid achievement object or missing id" }
        }

        const response = await apiCall('PUT', 1, null, 'achievements', '', '', '', achievement);

        return response;
    } catch (error) {
        return error
    }
};

const dataDeleteAchievementAsync = async (achievementIds) => {
    console.log('dataDeleteAchievementAsync', achievementIds);
    try {
        if (!achievementIds) {
            return { error: "Missing achievementIds" }
        }
        if (!Array.isArray(achievementIds)) {
            achievementIds = [achievementIds];
        }

        const response = await apiCall('DELETE', 1, null, 'achievements', '', '', '', achievementIds);

        return response;
    } catch (error) {
        return error
    }
}

const dataLoadAchievementsAsync = async () => {
    console.log('dataLoadAchievementsAsync');
    try {
        const response = await apiCall('GET', -1, { _: "" }, 'achievements', '', '', '', null);

        return response;
    } catch (error) {
        return error
    }
};

const dataLoadAchievementsFilterAsync = async (coreIds = [], mngrsIds = []) => {
    console.log('dataLoadAchievementsFilterAsync( [coreId * ', coreIds?.length || 0, '], [mngrsIds * ', mngrsIds?.length || 0, '] )');
    let query = '';
    if (coreIds.length > 0) {
        query += (query.length ? '?' : '') + "coreId@=" + coreIds.join(",");
    }
    if (mngrsIds.length > 0) {
        query += (query.length ? '?' : '') + "coreId@=teams(" + mngrsIds.join(",") + ")";
    }
    try {
        console.log('dataLoadAchievementsFilterAsync apiCall query:', query);
        const response = await apiCall('GET', -1, { _: "" }, 'achievementsq', '', query, '', null);
        return response;
    } catch (error) {
        return error
    }
}

const dataAddActivityAsync = async (activity) => {
    console.log('dataAddActivityAsync', activity.coreId, activity.activityId, activity.hours);
    try {
        if (!activity.group) activity.group = ourGroup;
        activity.type = 'activity';
        if (!checkActivity(activity)) {
            return { error: "Invalid activity object" }
        }

        const response = await apiCall('POST', 1, null, 'activities', '', '', '', activity);

        return response;
    } catch (error) {
        return error
    }
};

const dataAddActivitiesBatchAsync = async (activities) => {
    console.log('dataAddActivitiesBatchAsync', activities.length);
    try {
        if (!activities || !Array.isArray(activities) || activities.length === 0) {
            return { error: "Invalid activities array" }
        }
        let isAnyInvalid = false;
        activities = activities.reduce((acc, activity) => {
            if (!activity.group) activity.group = ourGroup;
            activity.type = 'activity';
            let isok = (checkActivity(activity));
            acc.push(isok);
            if (!isok) {
                isAnyInvalid = true;
            }
            return acc;
        }, []);
        if (isAnyInvalid) {
            return { error: "Invalid activity object" }
        }
        if (activities.length === 1) {
            return await dataAddActivityAsync(activities[0]);
        }

        const response = await apiCall('POST', activities.length, null, 'activities', '', '', '', activities);

        return response;
    } catch (error) {
        return error
    }
}

const dataUpdateActivityAsync = async (activity) => {
    console.log('dataUpdateActivityAsync', activity.id, activity.coreId, activity.activityId);
    try {
        if (!checkActivity(activity) || !activity.id) {
            return { error: "Invalid activity object or missing id" }
        }

        const response = await apiCall('POST', 1, null, 'activities', '', '', '', activity);

        return response;
    } catch (error) {
        return error
    }
}

const dataDeleteActivityAsync = async (activityIds) => {
    console.log('dataDeleteActivityAsync', activityIds);
    try {
        if (!activityIds) {
            return { error: "Missing activityIds" }
        }
        if (!Array.isArray(activityIds)) {
            activityIds = [activityIds];
        }

        const response = await apiCall('DELETE', 1, null, 'activities', '', '', '', activityIds);

        return response;
    } catch (error) {
        return error
    }
}

const dataLoadActivitiesAsync = async (coreId = null) => {
    console.log('dataLoadActivitiesAsync( ', coreId, ' )');
    let query = '';
    if (coreId) {
        query = 'coreId=' + coreId;
    }
    try {
        const response = await apiCall('GET', -1, { _: "" }, 'activities', '', query, '', null);

        return response;
    } catch (error) {
        return error
    }
}

const dataLoadActivitiesFilterAsync = async (coreIds = [], mngrsIds = []) => {
    console.log('dataLoadActivitiesFilterAsync( [coreId * ', coreIds?.length || 0, '], [mngrsIds * ', mngrsIds?.length || 0, '] )');
    let query = '';
    if (coreIds.length > 0) {
        query += (query.length ? '?' : '') + "coreId@=" + coreIds.join(",");
    }
    if (mngrsIds.length > 0) {
        query += (query.length ? '?' : '') + "coreId@=teams(" + mngrsIds.join(",") + ")";
    }
    try {
        console.log('dataLoadActivitiesFilterAsync apiCall query:', query);
        const response = await apiCall('GET', -1, { _: "" }, 'activitiesq', '', query, '', null);

        return response;
    } catch (error) {
        return error
    }
}

const dataEncUsers = async (users) => {
    let txt = JSON.stringify(users);
    let enc = await myCrypto.encrypt(txt, encKey);
    let retObj = { enc };
    let retStr = JSON.stringify(retObj);
    return retStr;
}

const dataLoadUsersAsync = async () => {
    console.log('dataLoadUsersAsync');
    try {
        const response = await apiCall('GET', -1, null, 'usersq', '', '', '', null);

        let ret = [];
        if (response && !response.error && Array.isArray(response)) {
            ret = response;

            ret.map((user) => {
                if (user.email) user.email = user.email.toLowerCase();
                if (user.coreId) user.coreId = user.coreId.toLowerCase();
                if (!user.coreId && user.coreid) user.coreId = user.coreid.toLowerCase();
                if (user.parent) user.parent = user.parent.toLowerCase();
                return user;
            });
        }
        return ret;
    } catch (error) {
        return error
    }
}

const dataLoadSomeUsersAsync = async (coreId, parent) => {
    console.log('dataLoadUsersAsync');
    try {
        let queryStr = '';
        if (coreId) {
            queryStr = 'coreId=' + coreId;
        }
        if (parent) {
            queryStr = (queryStr.length ? '&' : '') + 'parent=' + parent;
        }
        const response = await apiCall('GET', -1, queryStr ? {} : null, 'usersq', '', queryStr, '', null);

        let ret = [];
        if (response && !response.error && Array.isArray(response)) {
            ret = response;
            ret = ret.map((user) => {
                if (user.email) user.email = user.email.toLowerCase();
                if (user.coreId) user.coreId = user.coreId.toLowerCase();
                if (!user.coreId && user.coreid) user.coreId = user.coreid.toLowerCase();
                if (user.parent) user.parent = user.parent.toLowerCase();
                return user;
            });
        }
        return ret;
    } catch (error) {
        return error
    }
}

const dataLoadBadgesAsync = async () => {
    console.log('dataLoadBadgesAsync');
    try {
        const response = await apiCall('GET', -1, null, 'badges', '', '', '', null);

        return response.badges || [];
    } catch (error) {
        return error
    }
}

const dataLoadScoringAsync = async () => {
    console.log('dataLoadScoringAsync');
    try {
        const response = await apiCall('GET', -1, null, 'scoring', '', '', '', null);

        return response?.stages || [];
    } catch (error) {
        return error
    }
}

export {
    dataAddAchievementAsync,
    dataAddAchievementsBatchAsync,
    dataUpdateAchievementAsync,
    dataDeleteAchievementAsync,
    dataLoadAchievementsAsync,
    dataLoadAchievementsFilterAsync,
    dataAddActivityAsync,
    dataAddActivitiesBatchAsync,
    dataUpdateActivityAsync,
    dataDeleteActivityAsync,
    dataLoadActivitiesAsync,
    dataLoadActivitiesFilterAsync,
    dataLoadUsersAsync,
    dataLoadSomeUsersAsync,
    dataLoadBadgesAsync,
    dataLoadScoringAsync,
    dataEncUsers
}
